import FrameC, { FrameContextConsumer } from 'react-frame-component';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ChakraProvider } from '@chakra-ui/react';

const Frame = ({ children }) => (
  <FrameC
    title="form preview 1"
    height="100%"
    head={
      <link type="text/css" rel="stylesheet" href="/submize-form.css" />
  }
  >
    <div id="formpreview">
      <FrameContextConsumer>
        {(frameContext) => {
          const cache = createCache({
            key: 'formpreview',
            container: frameContext.document.head,
          });
          return (
            <CacheProvider value={cache}>
              <ChakraProvider>
                {children}
              </ChakraProvider>
            </CacheProvider>
          );
        }}
      </FrameContextConsumer>
    </div>
  </FrameC>
);

export default Frame;
